{
  "title": "Notifications",
  "bell": {
    "label": "Notifications",
    "unread": "{{unreadValue}} unread",
    "empty": "No notifications yet.",
    "seeAll": "See all",
    "markAllRead": "Mark all as read"
  },
  "list": {
    "empty": "You have no notifications.",
    "emptyUnread": "You have no unread notifications.",
    "unreadOnly": "Unread only",
    "markRead": "Mark as read",
    "delete": "Delete",
    "loadMore": "Load more"
  },
  "types": {
    "learning.enrolled": {
      "title": "Enrolment confirmed",
      "body": "You are enrolled in “{{courseTitle}}”."
    },
    "learning.new_student": {
      "title": "New student",
      "body": "A student has just enrolled in “{{courseTitle}}”."
    },
    "learning.attempt_to_grade": {
      "title": "A submission to grade",
      "body": "A submission is waiting in “{{courseTitle}}”."
    },
    "learning.attempt_graded": {
      "title": "Your submission has been graded",
      "body": "Your submission for “{{courseTitle}}” has been graded."
    },
    "learning.attempts_reset": {
      "title": "New attempts granted",
      "body": "Your teacher granted you new attempts in “{{courseTitle}}”."
    },
    "learning.course_completed": {
      "title": "Course completed",
      "body": "Congratulations, you have completed “{{courseTitle}}”."
    },
    "billing.subscription_activated": {
      "title": "Subscription active",
      "body": "Your subscription ({{planCode}}) is now active."
    },
    "unknown": {
      "title": "Notification",
      "body": "This notification cannot be displayed by this version of the application."
    },
    "messaging.new_message": {
      "title": "New message",
      "body": "{{senderName}} sent you a message."
    },
    "admin.warning": {
      "title": "Warning",
      "body": "Content you posted was reported and reviewed."
    },
    "learning.certificate_issued": {
      "title": "Your certificate",
      "body": "Your certificate for “{{courseTitle}}” is available (no. {{serial}})."
    },
    "admin.role_granted": {
      "title": "New administrator",
      "body": "The account “{{promotedName}}” has been granted the administrator role."
    }
  },
  "preferences": {
    "title": "Notification preferences",
    "intro": "Choose how you want to be notified. The in-app log cannot be turned off.",
    "channel": {
      "in_app": "In the app",
      "email": "By email"
    },
    "locked": "Cannot be turned off",
    "saved": "Preferences saved.",
    "saveFailed": "Preferences could not be saved."
  }
}
